import type { App } from 'vue'
import { inject } from 'vue'

const key = 'app.plugin.host'

export function provideHost(app: App, host: URL): void {
    app.provide(key, host)
}

export function useHost(): string {
    return (inject(key) as URL).host
}

export function useScheme(): string {
    return (inject(key) as URL).protocol
}
